import { apiWrapper } from 'ccs-ui-components';
import { call, fork, put, takeLatest } from 'redux-saga/effects';
import { headersInstance } from '../../../../common/utils/HeaderUtils';
import { IQueryParams } from '../../../models';
import { eventListSchema } from '../../../utilities/sources/RegistriesSchemaDefintion';
import { fetchEventList } from '../../actions/actionType/events/EventListActionTypes';
import {
  fetchAllEventFailure,
  getAllEventStarted,
  getAllEventSuccess
} from '../../actions/sagaActions/events/GetAllEventSagaActions';
import {
  FetchAllEventFailurePayload,
  FetchAllEventRequest,
  IListActiveEvent
} from '../../actions/types/events/GetAllEventListTypes';

/**
 * Call Gets Service Events by API
 * @returns api response
 */
export async function callGetAllEventApi(pageNo: number, item: number, queryParams?: IQueryParams, sort?: string) {
  const urlString = `${process.env.REACT_APP_API_CONTROL_PLANE_BASE_URL}/events/search?page=${pageNo}&size=${item}&sort=${sort || 'updatedTimestamp,DESC'}`;
  const requestBody = queryParams ? {
    events: queryParams.searchText ? [{
      eventName: queryParams.searchText
    }] : [],
    exactNameMatch: false,
    status: queryParams.status === '' ? [] : queryParams.status?.split(','),
    fromDate: queryParams.fromDate ? queryParams.fromDate : null,
    toDate: queryParams.toDate ? queryParams.toDate : null,
  } : {};
  const resp = await apiWrapper.post<IListActiveEvent, { errorMessage: string }>(
    urlString,
    requestBody,
    headersInstance()

  );

  const apiResponse = eventListSchema.validate(resp.responseBody, {
    abortEarly: true
  });

  if (apiResponse.error) {
    return {
      responseBody: undefined,
      isError: true,
      error: new Error('API VAlidation failed')
    };
  }

  return resp;
}

export function* getAllEvent({ pageNo, item, queryParams, sort }: FetchAllEventRequest) {
  yield put(getAllEventStarted());
  try {
    const { responseBody: data, isError, error } = yield call(callGetAllEventApi, pageNo, item, queryParams, sort);
    if (isError) {
      throw error;
    }
    if (data) {
      yield put(getAllEventSuccess(data));
    } else {
      throw new Error(error);
    }
  } catch (error) {
    const obj: FetchAllEventFailurePayload = {
      error: String(error)
    };
    yield put(fetchAllEventFailure(obj));
  }
}

/**
 * Saga Effect to consider latest request
 */
export function* fetchAllEventSaga() {
  yield takeLatest(fetchEventList.FETCH__EVENT_LIST_REQUEST, getAllEvent);
}

export const getAllEventSaga = [fork(fetchAllEventSaga)];
